import React, { useEffect } from 'react';
import { initFBPixel, trackPageView } from './utils/fbPixel';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    initFBPixel();
    trackPageView();
  }, []);
  return <SalesPage data-id="element-0" />;
}